import React from "react";
import { components } from "react-select";
import { TypeIcon } from "../../Constants/assets";
const MenuList = (props) => {
  const { options, setValue } = props;
  return (
    <components.MenuList {...props}>
      {options.map((option,index) => (
        <div
          key={index}
          className="feed-type-menu-item"
          onClick={() => {
            setValue(option);
          }}
        >
          {TypeIcon[option.value]&&<img src={TypeIcon[option.value]} alt="type"/>}
          {option.label}
        </div>
      ))}
    </components.MenuList>
  );
};

export default MenuList;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/MenuList.js